<div class="white container-fluid">
    <div class="lock-screen">
        <div class="animate fadeIn text-center">
            <!-- added 'row' class -->
            <div class="row">
                <div class="col-md-8 blue-seprator">
                    <!-- replaced 'img-responsive' class with 'img-fluid' -->
                    <img src="assets/images/RCM_1.jpg" class="img-fluid img-100">
                </div>
                <div class="col-md-4 p-0 bottom-align">

                    <div class="col-md-12">
                        <!-- added 'row' class -->
                        <div class="row mb-10 justify-content-lg-center">
                            <!-- *ngIf="loginservice && loginservice.hideGebbsLogo==false" -->
                          <ng-container *ngIf="!isCurrance;else isCurranceLogo">
                            <span class="col-md-6" *ngIf="!loginservice.isHideGebbsLogo">
                                <div>
                                    <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                    <img src="assets/images/logo_156.png" class="img-fluid img-100">
                                </div>
                            </span>
                            <span [ngClass]="{'blue-seprator-l' : loginservice && !loginservice.isHideGebbsLogo}" class="col-md-6">
                                <div>
                                    <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                    <img src="assets/images/iAR.png" class="img-fluid img-100">
                                </div>
                            </span>
                          </ng-container>

                          <ng-template #isCurranceLogo>
                            <span class="col-md-12">
                              <div>
                                  <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                  <img src="assets/images/iAR_Login.png" class="img-fluid img-100">
                              </div>
                            </span>
                          </ng-template>
                        </div>
                        <div class="col-md-12 text-center version-text"> Version: 6.1 </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-12 p-0">
                            <div class="heading-panel sT-hight p-0">
                                <span class="text-sm text-ellipsis heading-txt blue-text h-height title-border">Sign
                                    In</span>
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="MyForm" (ngSubmit)="getIP()" novalidate>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="username" class="label-std control-label p-0 b-600">Username</label>
                                <input required type="text" maxlength="20" class="form-control" formControlName="username" name="username" id="username" placeholder="Username">
                                <div class="error" *ngIf="MyForm.get('username').hasError('required') && DisplayError">
                                    Username is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-6">
                            <div class="form-group">
                                <label for="Password" class="label-std control-label p-0 b-600">Password</label>
                                <input maxlength="20" required type="password" name="password" class="form-control" id="Password" placeholder="Password" formControlName="password">
                                <div class="error" *ngIf="MyForm.get('password').hasError('required') && DisplayError">
                                    Password is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-10" *ngIf="MyForm.controls.captchaData as captcha">
                            <div class="form-group" style="margin-bottom:0">
                                <div class="captchaContainer">
                                  <img [src]="showCaptcha" alt="captcha" style="height: 50px;width: 200px;">

                                    <div class="controls">
                                        <div class="inputCtrl">
                                            <input class="form-control valid" formControlName="captchaData" type="text" placeholder="Type above text">
                                            <span class="errorSection" *ngIf="captcha.touched==true || DisplayError">
                                                <div class="error"
                                                    *ngIf="MyForm.get('captchaData').hasError('required') && DisplayError">
                                                    Captcha is required.
                                                </div>
                                                <div class="error"
                                                    *ngIf="captcha.errors && captcha.errors.invalidCaptcha">
                                                    Please type valid Captcha
                                                </div>
                                            </span>
                                        </div>
                                        <button title="Refresh Captcha Code" type="button" class="btn btn-primary refreshIconAlign" (click)="callCaptcha()">
                                            <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- added col-md-12 -->
                        <div class="col-md-12">
                            <!-- added 'row' class -->
                            <div class="row text-left">
                                <!-- removed pl pr classes -->
                                <div class="col-md-6" style="float: left;">
                                    <button *ngIf="!isLoaded" id="disclaimerModal" data-toggle="modal"  [disabled]="DisableSubmit" class="btn btn-default blue square-btn blue-hover btn-txt w-100">Sign
                                        in</button>
                                        <button *ngIf="isLoaded" class="btn btn-default blue square-btn blue-hover btn-txt w-100" type="button" disabled>
                                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="display: inline-block;margin: 0 5px;"></span>
                                          Loading...
                                        </button>
                                </div>
                                <!-- removed pl pr classes -->
                                <div class="col-md-6" style="float: right">
                                    <button type="submit" [disabled]="DisableSubmit" (click)="redirectForgot('/forgot-password')" class="btn btn-default blue square-btn blue-hover btn-txt w-100">Forgot
                                        password ?</button>
                                </div>
                            </div>
                        </div>

                    </form>

                    <div *ngIf="!loginservice.isHideGebbsLogo"  class="col-md-12 mt-15 text-center copy-text">
                        <span>Copyright &copy; {{CurrentYear}} GeBBS Healthcare Solutions</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 text-center">
      <p>
      <b>Security Notice:</b> You are using a secure web connection. Your password will be encrypted in transit to our web server, but will remain on your
      browser until you exit it.
      </p>
        <b>
            UNAUTHORIZED ACCESS TO THIS SERVICE IS PROHIBITED.<br />
        </b>
        <p>iAR is confidential and proprietary, and is for authorized users only. All authorized users are subject to
            contractual use restrictions and nondisclosure requirements that prevent giving access to third parties.
            Unauthorized users are subject to prosecution, lawsuits, and penalties under state and federal law. All
            system activities are monitored, recorded and reviewed by system personnel. Anyone using this system
            expressly consents to such monitoring and is hereby warned that if such monitoring reveals possible evidence
            of criminal activity by the user, the same shall be reported to law enforcement Agency. Provider reserves
            the right, at its sole discretion, to change, modify the software or program at any time without notice. Any
            rights not expressly granted herein are reserved.
        </p>
        <p>
          Contact: Infosec Team - infosec@gebbs.com
        </p>
    </div>

</div>
<div class="modal fade bd-example-modal-lg" id="myModal" role="dialog" [ngClass]="[isShow == true ? 'showmodal' : 'hidemodal']">
    <div class="modal-dialog"style="max-width: 750px!important;">
        <div class="modal-content modalContent" style="margin-top: 16%">
            <div class=" modalHeader" style="text-align: center;">
                <button type="button" class="close"style="font-size: 24px;" data-dismiss="modal"(click)="closeModal()">&times;</button>
                <h4 style="font-size: 19px;
                font-weight: 700;" class="modal-title"><i class="fa fa-warning"></i> Disclaimer</h4>
            </div>
            <div class="modal-body">


                <div class="disclaimer-text" style="font-size: 11px; line-height: 16px; text-align: justify;">
                    <p class="para">
                        <span style="font-weight: 700;">PLEASE READ THE TERMS AND CONDITIONS :</span>
                         This EULA is between you and GeBBS Healthcare Solutions, Inc. and set forth the terms and conditions pursuant to which you are authorized to access this platform. You agree to be bound by all the terms and conditions of this EULA. All rights, title, and interest on all these platforms belong to GeBBS Healthcare Solutions Inc. Subject to terms and conditions of this EULA, GeBBS grants you a non-exclusive, non-transferable revocable and restricted license to login and use the services of this platform. You agree not to sell, leaves, transfer, sublicense, distribute or otherwise make this platform available. You are responsible for maintaining the confidentiality of your user identification and password used to access this platform. You agree not to disclose or share your password with anyone. You must follow all privacy and security policies with respect to use of and access this platform.
                        <br> <br> <br>

                         <span style="font-weight: 700;">RIGHT TO MONITOR:</span>

                       GeBBS reserves the right to examine or to have its authorised agents to examine all user activity on this platform to determine if the data is secured. You consent for such monitoring.

                       <br> <br> <br>

                       <span style="font-weight: 700;">LIMITATION OF LIABILITY:</span>


                        Any use of this platform shall be at your sole risk. access to this platform is provided “AS IS” and “AS AVAILABLE” basis, without warranty, express or implied to the fullest extent permissible pursuant to applicable laws. GeBBS reserves the right to revoke without any notice your access to these platforms at any time and for any reason. GeBBS Shall not be liable for any damagers you suffer as a result of your use or reliance on this platform.

                       <br> <br> <br>
                       <span style="font-weight: 700;">INDEMNITY:</span>
                      You will defend, indemnify and hold GeBBS, its officers, directors employees agents, licensors and vendors harmless from and against any claims actions or demands, liabilities and settlements, including without limitation, legal and accounting fees resulting from or alleged to result from, (1) your violation of this EULA or, (2) any unauthorised use, disclosure access of any kind of critical data resulting from or relating to use of this platform.
                    </p>
                </div>
            </div>
            <div class="modal-footer"style="display: inline;">
                <button type="button" class="btn btn-rounded btn-primary"(click)="onAcceptDiscalimer()" style="margin-left:45%;font-size: 1.3rem;" data-dismiss="modal">Accept
                    </button>
            </div>
        </div>
    </div>
</div>
<!-- <p style="font-size: 20px;color: #cbd1d8;">Angular 13</p> -->
<div *ngIf="isLoaded" id="pause" class="d-flex align-items-center justify-content-center">
  <div id="spinner"></div>
</div>
